module.exports = __webpack_public_path__ + "img/arrival.c636fa26.svg";